// extracted by mini-css-extract-plugin
export default {"btn":"EditFlight_btn__aIO5U","btn_kiosk":"EditFlight_btn_kiosk__+1H5k","disabled":"EditFlight_disabled__ahZ2e","active":"EditFlight_active__yjKV9"};